// Detected at module-evaluation time, BEFORE React Router mounts. The public
// signer route must opt out of any telemetry / support tooling that would
// capture the bearer token in the URL or any rendered PHI (signatures, names).
export function isPublicSignerRoute() {
  return (
    typeof window !== 'undefined' &&
    window.location.pathname.startsWith('/sign/')
  );
}
